import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { RichTextTruncatorEntry } from "frontend/contentful/schema/blocks";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";
import { RichText } from "design-system/components/blocks/rich-text/rich-text";
import { Truncator } from "design-system/components/blocks/truncator/truncator";
import { createTruncatorProps } from "./truncator.props";
import { useContentful } from "frontend/hooks/use-contentful";

interface RichTextOptions {
  headerAbove?: boolean;
}

export const ContentfulRichTextTruncator = createContentfulComponent<
  RichTextTruncatorEntry,
  RichTextOptions
>(({ entry, options, createEditAttributes }) => {
  const { getEntry } = useContentful();
  const truncator = getEntry(entry.fields.truncator);

  const truncatorOption = { headerAbove: true };
  const props = createTruncatorProps(truncator, truncatorOption);

  return (
    <>
      <RichText
        useDropCap={entry.fields.useDropCap}
        editAttribute={createEditAttributes({ entry, fieldId: "text" })}
      >
        <RenderContentfulRichText
          document={entry.fields?.text}
          resetHeaders={options?.headerAbove ? "h3" : "h2"}
        />
      </RichText>

      <Truncator {...props} />
    </>
  );
});
